import { atu } from '@/api/api-endpoints'
import L from 'leaflet'
import { COLORS } from '@/utils'
import { getRandomInt } from '@/utils/random'
import { numberWithSpaces, toNumberFixed } from '@/utils'

export default {
  data() {
    return {
      objects: [],
      zoneLayer: null,
    }
  },
  methods: {
    async getObjects() {
      this.objects = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: atu.atuObjectUpdateOrCreate(),
          fromCache: false,
          notReactive: false,
        })
      ).data.data
    },
    getFlatCoords(object) {
      let polygon = JSON.parse(JSON.parse(object.polygon))
      polygon = polygon.flat()

      return polygon.map((first) => {
        if (first.length === 2) {
          return [first[1], first[0]]
        }
        first = first.map((el) => {
          if (Array.isArray(el)) {
            return [el[1], el[0]]
          }
          return el
        })
        return first
      })
    },
    addContentToPopupZone(name) {
      return `<div class='zone-popup'>
                <div class='zone-popup__name'>Модельная зона ${name}</div>
            </div>
        `
    },
    async setOptimalZones(optimalZones) {
      await this.getObjects()
      if (this.zoneLayer) {
        this.map.removeLayer(this.zoneLayer)
      }
      this.showOptimalText = false
      this.zoneLayer = L.featureGroup()
      const colors = Object.values(COLORS)
      const random = []
      Object.values(optimalZones).forEach((zone, index) => {
        let randomIndex = getRandomInt(0, colors.length - 1)

        while (random.includes(randomIndex)) {
          randomIndex = getRandomInt(0, colors.length - 1)
        }
        random.push(randomIndex)
        const color = colors[randomIndex]

        // количество обслуживаемого населения
        const totalResidents = zone.mos.reduce((acc, item) => {
          const object = this.objects.find((el) => el.id === item.id)
          return acc + (object ? object.total_residents || 0 : 0)
        }, 0)

        //  масса отходов
        const totalGarbage = zone.mos.reduce((acc, item) => {
          const object = this.objects.find((el) => el.id === item.id)
          return acc + (object ? object.total_garbage || 0 : 0)
        }, 0)
        //  объем отходов
        const totalGarbageCubic = zone.mos.reduce((acc, item) => {
          const object = this.objects.find((el) => el.id === item.id)
          return acc + (object ? object.total_garbage_cubic || 0 : 0)
        }, 0)

        zone.mos.forEach((item) => {
          const object = this.objects.find((el) => el.id === item.id)

          if (object) {
            const coords = this.getFlatCoords(object)
            const polygon = new L.polygon(coords, {
              color: color,
              fillColor: color,
              weight: 3,
            })
            const popup = L.popup()
            popup.setContent(this.addContentToPopupZone(index + 1))

            // строки для типов объектов
            let objectTypesInfo = zone.object_types
              .map((type) => `${type.action_name}: ${type.count}`)
              .join(', ')

            polygon.bindPopup(popup)
            polygon.bindTooltip(
              `количество МО, входящих в состав: ${zone.mos.length}<br>
                   затраты на управление: ${numberWithSpaces(
                     toNumberFixed(zone.control_cost)
                   )}<br>
                   затраты на транспортировку: ${numberWithSpaces(
                     toNumberFixed(zone.transportation_cost)
                   )}<br>
                   затраты на сбор: ${numberWithSpaces(
                     toNumberFixed(zone.collection_cost)
                   )}<br>
                   затраты на обработку: ${numberWithSpaces(
                     toNumberFixed(zone.processing_cost)
                   )}<br>
                   всего затрат: ${numberWithSpaces(
                     toNumberFixed(zone.total_cost)
                   )}<br>
                    количество объектов обращения по типам: ${objectTypesInfo}<br>
                    количество обслуживаемого населения: ${numberWithSpaces(
                      totalResidents
                    )}<br>
                    масса отходов: ${numberWithSpaces(totalGarbage)}<br>
                    объем отходов: ${numberWithSpaces(totalGarbageCubic)}<br>
              `
            )
            this.zoneLayer.addLayer(polygon)
          }
        })
      })
      this.zoneLayer.addTo(this.map)
      this.calculateTotal(optimalZones)
    },
    calculateTotal(zones) {
      const params = [
        'cost',
        'control',
        'collection',
        'transportation',
        'processing',
      ]

      params.forEach((param) => {
        this.zones[param] = 0
      })

      Object.values(zones).forEach((zone) => {
        this.zones.cost += Number(zone.total_cost)
        this.zones.control += Number(zone.control_cost)
        this.zones.collection += Number(zone.collection_cost)
        this.zones.transportation += Number(zone.transportation_cost)
        this.zones.processing += Number(zone.processing_cost)
      })

      params.forEach((param) => {
        this.zones[param] = numberWithSpaces(toNumberFixed(this.zones[param]))
      })
      this.showOptimalText = true
    },
  },
}
